const { locale, countryCode } = window.__i18n || {
  locale: 'en',
  countryCode: 'GB',
};

export { locale, countryCode };
